import { useState,useEffect } from "react";
import { useParams } from "react-router-dom";
import useCurrentUserProfile from "../../../../hooks/useCurrentUserProfile";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const LabHeadDashboard = () => {
  const {profile} = useCurrentUserProfile()
  const {university_name,dean_name,department_name}=useParams()
  const [labs, setLabs] = useState([]);
  const [lab_groups, setLabGroups] = useState([]);
  
  const [groupMemebers,setGroupMemebers] = useState([])

         const fetchLabs = async () => {
            try {
              const res = await axios.get(`${BASE_URL}/marketplace/university/labhead/labs`, {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                  "x-api-key": process.env.REACT_APP_X_API_KEY,
                },
              });
              // console.log("The labs are:",res)
              setLabs(res?.data || []);
            } catch (error) {
              console.log("Error while getting profiles", error);
              setLabs([]);
            }
          };
  // console.log("The lab groups are:",lab_groups)
   const fetchLabGroups = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/marketplace/university/labhead/group`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });
        // console.log("The lab groups are:",res)
        setLabGroups(res?.data || []);
        // console.log("The lab groups are:",res?.data)
      } catch (error) {
        console.log("Error while getting profiles", error);
        setLabGroups([]);
      }
    };

        useEffect(() => {
          fetchLabs();
        }, []);

  useEffect(() => {
    fetchLabGroups();
  }, []);
  
  return (
    <div className="min-h-screen">
      {/* Dashboard Card */}
      <div className="">
        <div className="">
          
          {/* Header with Icon */}
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 bg-[#e8f0f7] rounded-xl flex items-center justify-center">
              <svg className="w-6 h-6 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
            </div>
            <div>
              <h1 className="text-2xl font-semibold text-gray-900">
                {profile?.name}
              </h1>
              <p className="text-sm text-gray-500 mt-1">
                Welcome to your dashboard. You are managing this laboratory and its activities.
              </p>
            </div>
          </div>

          {/* Info Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            
            {/* University */}
            <div className="bg-white p-4 rounded-xl border border-gray-200 hover:border-[#0f6abf] transition-colors">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                  <svg className="w-4 h-4 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <div>
                  <p className="text-xs text-gray-500">University</p>
                  <p className="text-sm font-medium text-gray-900">{university_name}</p>
                </div>
              </div>
            </div>

            {/* Department */}
            <div className="bg-white p-4 rounded-xl border border-gray-200 hover:border-[#0f6abf] transition-colors">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                  <svg className="w-4 h-4 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <div>
                  <p className="text-xs text-gray-500">Department</p>
                  <p className="text-sm font-medium text-gray-900">{department_name}</p>
                </div>
              </div>
            </div>

            {/* Department Dean */}
            <div className="bg-white p-4 rounded-xl border border-gray-200 hover:border-[#0f6abf] transition-colors">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                  <svg className="w-4 h-4 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
                <div>
                  <p className="text-xs text-gray-500">Department Dean</p>
                  <p className="text-sm font-medium text-gray-900">{dean_name}</p>
                </div>
              </div>
            </div>

              {/* Laboratory */}
            <div className="bg-white p-4 rounded-xl border border-gray-200 hover:border-[#0f6abf] transition-colors">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                  <svg className="w-4 h-4 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                  </svg>
                </div>
                <div>
                  <p className="text-xs text-gray-500">Laboratory</p>
                  <p className="text-sm font-medium text-gray-900">{labs?.length} Labs</p>
                </div>
              </div>
            </div>

            {/* Groups */}
            <div className="bg-white p-4 rounded-xl border border-gray-200 hover:border-[#0f6abf] transition-colors">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                  <svg className="w-4 h-4 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <div>
                  <p className="text-xs text-gray-500">Groups</p>
                  <p className="text-sm font-medium text-gray-900">{lab_groups.length} Active Groups</p>
                </div>
              </div>
            </div>

            {/* Members */}
            <div className="bg-white p-4  rounded-xl border border-gray-200 hover:border-[#0f6abf] transition-colors">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                  <svg className="w-4 h-4 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                </div>
                <div>
                  <p className="text-xs text-gray-500">Members</p>
                  <p className="text-sm font-medium text-gray-900">23 Members</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default LabHeadDashboard;